module.exports = __webpack_public_path__ + "img/6f_r_tokiwa.737ddf7e.jpg";